import { Markdown } from '@cadstrom/sigma-engine-shared';

import { amrTableDirectiveDefinition, AMR_TABLE_DIRECTIVE } from './amr-table-plugin.js';
import { clauseMarkdownItemDefinition } from './clause-reference-plugin.js';
import { driveModesTableDirectiveDefinition, DRIVE_MODES_TABLE_DIRECTIVE } from './drive-modes-table-plugin.js';
import {
	floatsAndTiesTableDirectiveDefinition,
	FLOATS_AND_TIES_TABLE_DIRECTIVE,
} from './floats-and-ties-table-plugin.js';
import { modelRenderDirectiveDefinition, MODEL_RENDER_DIRECTIVE } from './model-render-plugin.js';
import { hilReviewTableDirectiveDefinition, HIL_REVIEW_TABLE_DIRECTIVE } from './hil-review-table-plugin.js';
import { moduleMarkdownItemDefinition, moduleReferenceEditorPlugin } from './module-reference-plugin.js';
import { netMarkdownItemDefinition, netReferenceEditorPlugin } from './net-reference-plugin.js';
import { ocsTableDirectiveDefinition, OCS_TABLE_DIRECTIVE } from './ocs-table-plugin.js';
import {
	parametersAndModesTableDirectiveDefinition,
	PARAMETERS_AND_MODES_TABLE_DIRECTIVE,
} from './parameters-and-modes-table-plugin.js';
import { pdfCitationMarkdownItemDefinition } from './pdf-citation-plugin.js';
import { pinoutTableDirectiveDefinition, PINOUT_TABLE_DIRECTIVE } from './pinout-table-plugin.js';
import { severityMarkdownItemDefinition } from './severity-reference-plugin.js';
import {
	sigmaModelSignalPinsTableDirectiveDefinition,
	SIGMA_MODEL_SIGNAL_PINS_TABLE_DIRECTIVE,
} from './sigma-model-signal-pins-table-plugin.js';
import { signalMarkdownItemDefinition } from './signal-reference-plugin.js';
import { signalsTableDirectiveDefinition, SIGNALS_TABLE_DIRECTIVE } from './signals-table-plugin.js';
import { sourcesDirectiveDefinition, SOURCES_DIRECTIVE } from './sources-plugin.js';

import type { ComponentType } from 'react';
import type { MarkdownReferenceEditorPlugin } from './markdown-editor-reference-plugin.js';
import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/**
 * Collection of plugins supported for rendering markdown content via remark directives.
 */
export const RemarkMarkdownPlugins: {
	[key: string]: RemarkMarkdownDirectiveDefinition;
} = {
	[Markdown.ClauseReferenceMarkdownDirectiveDefinition.directive]: clauseMarkdownItemDefinition,
	[Markdown.ModuleReferenceMarkdownDirectiveDefinition.directive]: moduleMarkdownItemDefinition,
	[Markdown.NetReferenceMarkdownDirectiveDefinition.directive]: netMarkdownItemDefinition,
	[Markdown.PdfCitationMarkdownDirectiveDefinition.directive]: pdfCitationMarkdownItemDefinition,
	[Markdown.SignalReferenceMarkdownDirectiveDefinition.directive]: signalMarkdownItemDefinition,
	[Markdown.SeverityMarkdownDirectiveDefinition.directive]: severityMarkdownItemDefinition,
	[MODEL_RENDER_DIRECTIVE]: modelRenderDirectiveDefinition,
	[HIL_REVIEW_TABLE_DIRECTIVE]: hilReviewTableDirectiveDefinition,
	[SIGNALS_TABLE_DIRECTIVE]: signalsTableDirectiveDefinition,
	[PINOUT_TABLE_DIRECTIVE]: pinoutTableDirectiveDefinition,
	[DRIVE_MODES_TABLE_DIRECTIVE]: driveModesTableDirectiveDefinition,
	[AMR_TABLE_DIRECTIVE]: amrTableDirectiveDefinition,
	[OCS_TABLE_DIRECTIVE]: ocsTableDirectiveDefinition,
	[FLOATS_AND_TIES_TABLE_DIRECTIVE]: floatsAndTiesTableDirectiveDefinition,
	[PARAMETERS_AND_MODES_TABLE_DIRECTIVE]: parametersAndModesTableDirectiveDefinition,
	[SIGMA_MODEL_SIGNAL_PINS_TABLE_DIRECTIVE]: sigmaModelSignalPinsTableDirectiveDefinition,
	[SOURCES_DIRECTIVE]: sourcesDirectiveDefinition,
};

/**
 * Collection of editor plugins supported for the markdown editor.
 */
export const MarkdownReferenceEditorPlugins: MarkdownReferenceEditorPlugin[] = [
	moduleReferenceEditorPlugin,
	netReferenceEditorPlugin,
];

export function GetMarkdownPluginsObject() {
	const obj: { [key: string]: ComponentType<any> } = {};
	for (const [plugin, value] of Object.entries(RemarkMarkdownPlugins)) {
		obj[plugin] = value.item;
	}

	return obj;
}

export function GetMarkdownPluginSanitizeAttributes() {
	const attributes: Record<string, string[]> = {};
	for (const [plugin, value] of Object.entries(RemarkMarkdownPlugins)) {
		attributes[plugin] = value.allowedAttributes;
	}

	return attributes;
}
